import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  Head: {
    A_Transid: "",
    A_Date: "",
    A_Location: "",
    Loc_Name: "",
    A_Narration: "",
    A_Status: "",
    A_Confirm_Status: "",
    CreatedBy: "",
    CreatedDt: "",
    ConfirmBy: "",
    ConfirmDt: "",
    A_Vendor: "",
  },
};

const SliceMOQApprove = createSlice({
  name: "SliceMOQApprove",
  initialState: { value: initialState },

  reducers: {
    Head_Set: (state, action) => {
      state.value.Head = action.payload;
    },

    ItemListApprove_Init: (state) => {
      state.value = initialState;
    },
  },
});

export const { Head_Set, ItemListApprove_Init } =
  SliceMOQApprove.actions;
export default SliceMOQApprove.reducer;
